import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { useI18next } from "gatsby-plugin-react-i18next"
import styled from "styled-components"
import VideoModal from "components/Banners/VideoModal"
import InnerWrapper from "components/InnerWrapper"
import Callout from "components/TextElements/Callout"
import colors from "styles/colors"
import media from "styles/media"
import text from "styles/text"
import useMedia from "utils/useMedia"
import { useState } from "react"

export default function TheSolution() {
  const [showVideo, setShowVideo] = useState(false)
  const images: Queries.B2BTheSolutionQuery = useStaticQuery(graphql`
    query B2BTheSolution {
      mainPic: file(relativePath: { eq: "b2b/theSolution.webp" }) {
        ...LocalImageQuery
      }
      mainPicM: file(relativePath: { eq: "b2b/theSolutionMobile.webp" }) {
        ...LocalImageQuery
      }
    }
  `)
  const { t } = useI18next()
  const [MainPic, MainPicMobile] = [
    images.mainPic?.childImageSharp?.gatsbyImageData,
    images.mainPicM?.childImageSharp?.gatsbyImageData,
  ]

  const mainPic = useMedia(MainPic, MainPic, MainPic, MainPicMobile)

  return (
    <Wrapper>
      <InnerWrapper
        setWidth={useMedia("1440px", "86.747vw", "81.445vw", "89.867vw")}
      >
        <InnerInnerWrapper>
          <CalloutSection>
            <Callout
              variant="lightmode"
              kicker={{
                text: t("THE SOLUTION") ?? "THE SOLUTION",
                icon: "discs2",
                color: colors.seaFoam300,
              }}
              title={{
                content:
                  t("Clarity and control for your business expenses.") ??
                  "",
                size: useMedia(text.h3, text.h3, text.h3, text.h1Mobile),
                width: useMedia("100%", "100%", "100%", "100%"),
              }}
              text={{
                width: useMedia("100%", "100%", "67.578vw", "100%"),
                content: t(
                  `Dive into a new era of financial transparency, tailored to your business needs. Galileo's platform offers virtual cards for precise spend management and streamlines expense management charges. Our advanced APIs and tailored dashboard offer transparency and control, from custom spending groups to managing corporate credit limits.`
                ),
              }}
              buttons={[
                {
                  text: t("Watch the Video") ?? "",
                  type: "secondary",
                  arrow: true,
                  onClick: () => setShowVideo(true),
                 // route: links.guides,
                },
              ]}
            />
          </CalloutSection>
          {mainPic && (
            <BigPic
              image={mainPic}
              alt={t("a picture of a man holding pen")}
              loading="lazy"
            />
          )}
        </InnerInnerWrapper>
      </InnerWrapper>
      {mainPic && (
        <BigPicMobile
          image={mainPic}
          alt={t("a picture of a man holding pen")}
          loading="lazy"
        />
      )}
       {showVideo && (
        <VideoModal
          setShow={() => {
            setShowVideo(false)
          }}
          open={!!true}
        >
          <VideoIframe
            allow="fullscreen;"
            title="Generic title"
            src="https://www.youtube.com/embed/r_gmgHR3qEM"
            width="100%"
            height="auto"
          />
        </VideoModal>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  ${media.fullWidth} {
    padding-top: 150px;
    padding-bottom: 200px;
  }
  ${media.desktop} {
    padding-top: 9.036vw;
    padding-bottom: 12.048vw;
  }
  ${media.tablet} {
    padding-top: 14.648vw;
    padding-bottom: 11.719vw;
  }
  ${media.mobile} {
    padding-top: 21.333vw;
    padding-bottom: 21.333vw;
    flex-direction: column;
  }
`
const InnerInnerWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;

  ${media.tablet} {
    flex-direction: column;
    justify-content: space-between;
  }
  ${media.mobile} {
    flex-direction: column;
    justify-content: space-between;
  }
`

const CalloutSection = styled.div`
  ${media.fullWidth} {
    width: 645px;
  }
  ${media.desktop} {
    width: 38.855vw;
  }
  ${media.tablet} {
    width: 100%;
  }
  ${media.mobile} {
    width: 100%;
  }
`

const BigPic = styled(GatsbyImage)`
  object-fit: cover;
  ${media.fullWidth} {
    width: 842px;
    height: 549px;
    margin-top: -15px;
    margin-left: 23px;
  }
  ${media.desktop} {
    width: 842px;
    height: 524px;
    margin-top: -0.904vw;
    margin-left: 1.386vw;
  }
  ${media.tablet} {
    width: 70.508vw;
    width: 100%;
    margin-top: 5.859vw;
  }
  ${media.mobile} {
    width: 89.333vw;
    height: 92.8vw;
    margin-top: 10.667vw;
    display: none;
  }
`

const BigPicMobile = styled(GatsbyImage)`
  object-fit: cover;
  display: none;

  ${media.mobile} {
    display: initial;
    width: 100%;
    margin-top: 10.667vw;
  }
`
const VideoIframe = styled.iframe`
  position: relative;
  aspect-ratio: 16/9;

  outline: none;
  border: none;
  overflow: hidden;

  ${media.fullWidth} {
    margin: 100px 0;
    border-radius: 20px;
  }
  ${media.desktop} {
    margin: 6.024vw 0;
    border-radius: 1.205vw;
  }
  ${media.tablet} {
    margin: 9.766vw 0;
    border-radius: 1.953vw;
  }
  ${media.mobile} {
    margin: 13.333vw 0;
    border-radius: 2.667vw;
  }
`